<template>
    <div 
        v-if="items && items.length > 1"
        class="list-group list-group-alo list-group-flush sticky-top stick-top-with-header top-70"
    >
        <h6 class="list-group-item">
            On This Page
        </h6>
        <a 
            v-for="item in items" 
            :key="item.id"
            :href="`#${item.id}`"
            class="list-group-item list-group-item-action"
            @click="$emit('navigate', item.id)"
        >
            {{ item.label }}
        </a>
    </div>
</template>

<script>
export default {
    name: 'OnThisPage',
    props: {
        items: {
            type: Array,
            required: true,
            default: () => []
        }
    }
}
</script>
